<script setup>
import { useSeoMeta } from '@unhead/vue'
import { useGlobalStore } from '@stores/global'
import { useNewsStore } from '@stores/news'
import Hero from '@sections/global/Hero.vue'
import Articles from '@sections/news/Articles.vue'
import Loading from '@components/global/Loading.vue'

const global = useGlobalStore()
const newsStore = useNewsStore()

useSeoMeta({
	title: () => global.pages.find((page) => page.path === 'news')?.title ?? global.pages.find((page) => page.path === '/')?.title,
	description: () => global.pages.find((page) => page.path === 'news')?.description ?? global.pages.find((page) => page.path === '/')?.description,
	image: () => global.pages.find((page) => page.path === 'news')?.image ?? global.pages.find((page) => page.path === '/')?.image,
})
</script>

<template>
	<Loading v-if="newsStore.articles.length === 0" />
	<main v-else>
		<Hero :rive="{ src: 'https://cdn.papercrowns.com/website/rive/lockups/news.riv', height: 512, width: 1080 }" titleSvg="https://cdn.papercrowns.com/website/images/elements/lockups/news.svg" subtext="Storied and legend. We are the news." />
		<Articles />
	</main>
</template>
